import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

interface DurationPickerProps {
  options: number[]
  value: number
  onChange: (v: number) => void
  disabledOptions?: number[]
}

export function DurationPicker({
  options,
  value,
  onChange,
  disabledOptions = [],
}: DurationPickerProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>Duration</Label>
      <div className="flex gap-1.5">
        {options.map((d) => (
          <Button
            key={d}
            size="sm"
            variant={value === d ? 'default' : 'outline'}
            onClick={() => onChange(d)}
            disabled={disabledOptions.includes(d)}
            className="text-xs px-3"
          >
            {d}s
          </Button>
        ))}
      </div>
    </div>
  )
}
